import React, { Component } from 'react'
import { reduxForm } from 'redux-form'
import _ from 'lodash'
import { withStyles } from '@material-ui/core/styles';
import { Icon, Dropdown } from 'semantic-ui-react'

const styles = {
  button: {
    icon: {
      marginRight: '10px'
    }
  }
}

const iconStyle = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  margin: 'auto',
  right: '2.5em',
  lineHeight: 1,
  zIndex: 1,
}

const containerStyle = {
  position: 'relative',
  display: 'inline-block',
  width: '40vw'
}
class CompanyFilters extends Component {

    handleClear() {
        console.log("Clearing the state")
    } 

  render() {

    return (

        <div style={containerStyle}>
            {this.props.value!='' && <Icon link name="close" style={iconStyle} onClick={() => this.props.handleClear()} />}
                <Dropdown
                    placeholder = "Seleccione un proyecto"
                    fluid   
                    search
                    selection
                    value = {this.props.value}
                    options={this.props.options}
                    onSearchChange={this.props.handleSearchChange()}
                    onChange={this.props.handleChange()}
                />
        </div>
    )
  }
}

export default reduxForm({
    form: 'redux-form'
})(withStyles(styles)(CompanyFilters))
